console.log('script lodaed');
// colorSwatchDisplay();
document.querySelectorAll('.grid-item').forEach(productGrid => {
    productGrid.querySelectorAll('.product-card-swatches').forEach(item => {
        item.querySelectorAll('.product-card-swatch').forEach(card => {
            card.addEventListener('click', function(e) {
                console.clear();
                console.log('checking');
                e.preventDefault();
                e.stopPropagation();
                item.querySelectorAll('.product-card-swatch').forEach(card => {
                    card.classList.remove('active');
                })
                this.classList.add('active');
                let productTitle = card.dataset.productHandle;
                console.log(card.dataset, 'swatchProduct');
                let productUrl = `https://karenmizrahi.co.il/products/${productTitle}.js`;
                fetch(productUrl)
                    .then(response => {
                        if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                      let titleElement = this.closest('.grid-item').querySelector('.product-item__title');
                      let priceElement = this.closest('.grid-item').querySelector('.product-item__price');
                      let linkToElement = this.closest('.grid-item').querySelectorAll('.product-link');
                      let mainImage = this.closest('.grid-item').querySelector('.product-item__bg img');
                      let quickAddItem = this.closest('.grid-item').querySelector('input[type="hidden"][name="id"]');
                      let secondaryImages = this.closest('.grid-item').querySelectorAll('.product-item__bg__under .product-item__bg__slider figure');
                      if(quickAddItem){
                        quickAddItem.value = data.variants[0]['id'];
                      }
                      if (titleElement) {
                        titleElement.textContent = data.title;
                      }
                      let price = (data.price/100).toFixed(2);
                      if(data.price_varies){
                      	priceElement.innerHTML = `<span>From NIS</span>${price}`
                      }else{
                      	priceElement.innerHTML = `NIS${price}`
                      }
                      linkToElement.forEach(link => {
                        link.href= data.url;
                      });
                      let mainImageFigure = this.closest('.grid-item').querySelector('.product-item__bg figure');
                      let currentImage = mainImageFigure.querySelector('img');
                      if (currentImage) {
                          currentImage.remove();
                      }
                      let newImage = document.createElement('img');
                      newImage.src = data.images[0];
                      mainImageFigure.appendChild(newImage);

// Iterate through each of the selected elements
secondaryImages.forEach(slider => {
    // Find and remove all <img> tags within the slider element
    let currentImages = slider.querySelectorAll('img');
    currentImages.forEach(img => img.remove()); // Remove each <img> tag

    // Create a new <img> element
    let newImage = document.createElement('img');
    newImage.src = data.images[1]; // Set the src to the new image URL

    // Append the new image to the current slider element
    slider.appendChild(newImage);
});
                    })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                });
            })
        });
    });

    productGrid.addEventListener('mouseover', function(){
        if(productGrid.querySelector('.product-card-swatches--container'))
            productGrid.querySelector('.product-card-swatches--container').classList.add('active');
    })

    productGrid.addEventListener('mouseleave', function(){
        if(productGrid.querySelector('.product-card-swatches--container'))
            productGrid.querySelector('.product-card-swatches--container').classList.remove('active');
    })
});

// quick add cart
document.addEventListener('click', function (e) {
    // Check if the clicked element matches the .swatchProduct selector
    if (e.target.classList.contains('swatchProduct')) {
        console.clear();
        console.log('checking');
        e.preventDefault();
        e.stopPropagation();

        const card = e.target;
        const item = card.closest('.product-quick-add__inner');

        // Remove the active class from all swatchProducts in the same container
        item.querySelectorAll('.swatchProduct').forEach(card => {
            card.classList.remove('active');
        });

        // Add active class to the clicked element
        card.classList.add('active');

        const productTitle = card.dataset.productHandle;
        console.log(card, 'swatchProduct');
        const productUrl = `https://karenmizrahi.co.il/products/${productTitle}.js`;

        fetch(productUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                console.clear();
                const closeButton = document.querySelector('dialog[open="true"] button.product-quick-add__close.drawer__close');
                const currentProductIdElement = item.querySelector('#currentProductId');
                  const itemCurrent = currentProductIdElement.textContent.trim();
              console.log(data.id, itemCurrent)
              if (currentProductIdElement) {
                  if (data.id == itemCurrent) {
                    console.log("Already on the same variatn");
                  } else {
                    if (closeButton) {
                        closeButton.click();
                    }
                   const quickAddButton = document.querySelector(`div[data-quick-add-holder="${data.id}"] button`);
                    if (quickAddButton) {
                        quickAddButton.click();
                    } else {
                      console.log("id doesnt match");
                    }
                  }
              }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }
});
// quick add cart
